export default __webpack_public_path__ + "../staticImages/sprite-packstation-2x.png";